export const DEFAULT_STATE_ATTENDTICKETS = "1";
export const DEFAULT_STATE_APPROVETICKETS = "2";
export const ATTEND_TICKETS_TYPE = "1";
export const APPROVE_TICKETS_TYPE = "2";
export const STATUS_PENDING = "Pendiente";
export const STATUS_PENDING_APPROVE = "Pendiente de aprobación";
export const STATUS_TO_VERIFY = "Por verificar";
export const EMPTY_TEXT = "";
export const ONE_TEXT = "1";
export const STATUS_CODE_PENDING_APPROVE = "2";
export const DEFAULT_SEND_MAIL = true;
export const DEFAULT_SEND_NOTIFICATION = true;
export const DEFAULT_CONFIRM_ACCEPT = "Aceptar";
export const DEFAULT_CONFIRM_CANCEL = "Cancelar";
export const DEFAULT_CONFIRM_YES = "Si";
export const DEFAULT_CONFIRM_NO = "No";
export const DEFAULT_PASSWORD = "Prodac01";
export const NO_APPROVE_TICKET = "AprobTI|0";
export const NO_ATTEND_TICKET = "ADHelpDesk|0";
export const REQUERIMENTS_USER_SAP =
  "PR-03 Reseteo de Clave de Usuario SAP | PR-04 Desbloquear Usuario SAP | C4-02 Reseteo de Clave de Usuario | C4-03 Desbloquear/Bloquear usuario | QA-03 Reseteo de Clave de Usuario SAP | QA-04 Desbloquear Usuario SAP | Q4-02 Reseteo de Clave de Usuario | Q4-03 Desbloquear Usuario";
  export const RUTASFAB_MD_DENIED_PERMISSION = "0@USRutasFabMd";
  export const RUTASFAB_SOL_DENIED_PERMISSION = "00@USRutasFabSol";